<template>
  <router-view />
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    // if (sessionStorage.getItem('NAME') === 'gaoxin5760') {
    //   document.body.style.height = '1470px'
    // }
    return {}
  },
  methods: {
  },
  mounted() {
    //
  },
})
</script>
